/**
 * Component Registry for West 39th Street Apartments
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { ContactForm } from './components/ContactForm';
import { FloorplansList } from './components/FloorplansList';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { PropertyOverview } from './components/PropertyOverview';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { SisterProperties } from './components/SisterProperties';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ContactForm,
  FloorplansList,
  Footer,
  Header,
  Hero,
  HeroSolidBG,
  PropertyOverview,
  ScheduleTourForm,
  SisterProperties,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
